"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M19.887 10.627a.5.5 0 0 0-.708 0l-.157.156a7.009 7.009 0 0 0-13.224-3.04.502.502 0 0 0 .889.463 6.006 6.006 0 0 1 11.333 2.556l-.137-.136a.501.501 0 0 0-.708.709l1.002 1.002a.5.5 0 0 0 .708 0l1.002-1.002a.5.5 0 0 0 0-.708m-1.864 4.92a.5.5 0 0 0-.676.212 6 6 0 0 1-5.331 3.238 6.01 6.01 0 0 1-6-5.793l.134.135a.5.5 0 0 0 .709 0 .5.5 0 0 0 0-.708l-1.002-1.002a.5.5 0 0 0-.708 0L4.147 12.63a.502.502 0 0 0 .708.709l.157-.157a7.02 7.02 0 0 0 7.005 6.814 7 7 0 0 0 6.219-3.775.5.5 0 0 0-.213-.677z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M14.159 9.343a2.143 2.143 0 1 0-4.285-.005 2.143 2.143 0 0 0 4.285.005m-5.65 5.827c0 1.195 2.453 1.323 3.507 1.323s3.507-.128 3.507-1.323c0-1.706-1.278-2.685-3.507-2.685s-3.507.979-3.507 2.685"
  })]
}), 'UpgradeFilled');
//# sourceMappingURL=index.js.map